import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { App } from './components/App';
import reportWebVitals from './reportWebVitals';
import '@fontsource/nunito-sans';
import '@fontsource/source-serif-pro';
import { theme } from 'utils/createTheme';
import { RootStore, RootStoreContext } from 'stores/RootStore';
import { ThemeProvider } from '@mui/material';
import { initFeatureFlagger } from '@bowery-valuation/feature-flagger-client';
import { googleClientId, launchDarklyClientSideId } from 'utils/config';
import GoogleLoader from 'components/GoogleMapsLoader';

(async () => {
  if (launchDarklyClientSideId) {
    await initFeatureFlagger(launchDarklyClientSideId, null);
  }

  const rootStore = new RootStore();
  rootStore.init();

  if (googleClientId) {
    await new Promise<void>((resolve) => {
      (window as any).onGoogleLibraryLoad = () => {
        const google = (window as any).google;
        google.accounts.id.initialize({
          client_id: googleClientId,
          callback: (response: any) => {
            rootStore.socialAuthStore.handleGoogleAuthResponse(response);
          },
        });
        resolve();
      };
      if (document.readyState === 'complete') {
        (window as any).onGoogleLibraryLoad();
      }
    });
  }

  const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

  root.render(
    <React.StrictMode>
      <RootStoreContext.Provider value={rootStore}>
        <ThemeProvider theme={theme}>
          <GoogleLoader />
          <App />
        </ThemeProvider>
      </RootStoreContext.Provider>
    </React.StrictMode>
  );

  // If you want to start measuring performance in your app, pass a function
  // to log results (for example: reportWebVitals(console.log))
  // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
  reportWebVitals();
})();
